import { A11yModule } from '@angular/cdk/a11y';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { PlatformModule } from '@angular/cdk/platform';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import {
	DateAdapter,
	MAT_DATE_FORMATS,
	MAT_DATE_LOCALE,
	MatNativeDateModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatDialogConfig,
	MatDialogModule,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import {
	MAT_PAGINATOR_DEFAULT_OPTIONS,
	MatPaginatorDefaultOptions,
	MatPaginatorModule,
} from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';

import { DateFnsAdapter, MatDateFnsModule } from '@angular/material-date-fns-adapter';
import { MatTabsModule } from '@angular/material/tabs';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { AtsIconsModule } from '@ats/icons';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { enUS } from 'date-fns/locale';
import { AtsOverlayContainerDirective } from './directives/ats-overlay-container.directive';
import { DATE_FNS_CM_FORMATS } from './models/date-adapter';

const imports = [
	CommonModule,
	EditorModule,
	AtsIconsModule,
	ClipboardModule,
	MatButtonModule,
	MatCheckboxModule,
	MatChipsModule,
	MatDialogModule,
	MatFormFieldModule,
	MatInputModule,
	MatMenuModule,
	MatRadioModule,
	MatSelectModule,
	MatSnackBarModule,
	MatSlideToggleModule,
	MatStepperModule,
	MatTabsModule,
	MatTooltipModule,
	ScrollingModule,
	OverlayModule,
	A11yModule,
	LayoutModule,
	MatDatepickerModule,
	MatNativeDateModule,
	MatTreeModule,
	DragDropModule,
	PlatformModule,
	PortalModule,
	MatPaginatorModule,
	MatDividerModule,
	MatDateFnsModule,
];

const providers = [
	{ provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
	{ provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
	{ provide: MAT_DATE_FORMATS, useValue: DATE_FNS_CM_FORMATS },
	{ provide: MAT_DATE_LOCALE, useValue: enUS },
	{
		provide: MAT_DIALOG_DEFAULT_OPTIONS,
		useValue: {
			...new MatDialogConfig(),
			closeOnNavigation: true,
			hasBackdrop: true,
			autoFocus: true,
			panelClass: 'global-zoomed-dialog',
		} as MatDialogConfig,
	},
	{
		provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
		useValue: {
			showDelay: 500,
			position: 'above',
		},
	},
	{
		provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
		useValue: {
			subscriptSizing: 'dynamic',
		},
	},
	{
		provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
		useValue: {
			formFieldAppearance: 'fill',
		} as MatPaginatorDefaultOptions,
	},
];

@NgModule({
	declarations: [AtsOverlayContainerDirective],
	imports,
	exports: [...imports, [AtsOverlayContainerDirective]],
	providers,
})
export class AtsUiModule {}
